export const Navigation = 'components/Navigation';

export const Navigationi18n = {
  en: {
    menuList: {
      signOut: 'Sign out',
      settings: 'Settings',
      themeSwitcher: {
        title: 'Theme switcher',
        dark: 'Dark',
        light: 'Light',
      },
    },
    connection: {
      connected: 'Live data connected',
      reconnecting: 'Reconnecting to live data ...',
      disconnected: 'Live data disconnected',
      idle: 'No live data connection',
    },
  },
};
